module.exports = __webpack_public_path__ + "static/img/page_07.729298c4.png";